var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFloorViewYellow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_992_7992",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D2A437"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_992_7992)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_992_7992",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 19
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.716797,
    y: 0.714844,
    width: 18.2847,
    height: 18.2847,
    fill: "#D2A437"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_992_7992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.53078 1.58295C3.53078 2.39012 3.54216 3.13345 3.52476 3.87608C3.51807 4.1605 3.60371 4.2442 3.86664 4.23285C4.35637 4.21157 4.84878 4.23852 5.33851 4.21653C5.6108 4.20448 5.67771 4.31371 5.67637 4.58536C5.66968 5.56631 5.69376 6.54797 5.6844 7.52891C5.68172 7.81547 5.77338 7.89349 6.03163 7.88569C6.64446 7.86724 7.25863 7.86937 7.87213 7.8793C8.09559 7.88285 8.18859 7.82185 8.18591 7.56367C8.17454 6.42881 8.18859 5.29394 8.17119 4.15908C8.16919 4.00659 8.07619 3.82146 7.96981 3.71152C7.28406 3.00081 6.58291 2.30713 5.88711 1.60777C5.83025 1.55103 5.76201 1.49996 5.72588 1.43045C5.69979 1.3808 5.6951 1.27724 5.72521 1.24674C5.75799 1.21341 5.855 1.2127 5.9005 1.24107C5.98479 1.29427 6.0537 1.37654 6.12663 1.4496C9.38214 4.71658 12.637 7.98357 15.8918 11.2506C16.3695 11.73 16.8566 12.1996 17.3195 12.694C17.4306 12.8124 17.5209 13.0124 17.5236 13.177C17.5417 14.2289 17.5363 15.2807 17.5276 16.3333C17.5269 16.444 17.4527 16.5539 17.4132 16.6646C17.3617 16.5532 17.2667 16.4433 17.2654 16.3312C17.2533 15.3502 17.2486 14.3686 17.2627 13.3876C17.2667 13.1139 17.1844 12.9259 16.9957 12.7443C16.4351 12.2031 15.8912 11.6428 15.3392 11.0917C15.2783 11.0307 15.2081 10.9803 15.099 10.8888V14.426C15.2984 14.426 15.4964 14.4076 15.6878 14.4353C15.7654 14.4466 15.8905 14.558 15.8912 14.6253C15.9039 15.7226 15.9005 16.8192 15.9005 17.9533C15.7527 17.9633 15.6356 17.9782 15.5178 17.9782C11.0447 17.9782 6.5722 17.9753 2.09905 17.9817C1.82876 17.981 1.73242 17.9101 1.73242 17.6079C1.74112 12.3712 1.74045 7.13384 1.74179 1.89716C1.74179 1.74183 1.71904 1.5794 1.94651 1.58153C2.45765 1.58649 2.96813 1.58295 3.53145 1.58295H3.53078ZM11.602 11.2711C11.616 11.1505 11.6288 11.0924 11.6294 11.0349C11.6308 9.88942 11.6375 8.74322 11.6221 7.59842C11.6201 7.45727 11.5284 7.28563 11.4287 7.18278C10.6132 6.34369 9.78624 5.51737 8.96199 4.68892C8.82149 4.54777 8.67497 4.41514 8.46958 4.21937C8.46958 5.44644 8.46757 6.57634 8.4756 7.70624C8.4756 7.76156 8.56592 7.86653 8.60606 7.86228C8.96801 7.8254 8.92653 8.09493 8.93121 8.32615C8.94928 9.21206 8.96935 10.0972 8.97671 10.9831C8.97872 11.2137 9.05632 11.2952 9.27309 11.2853C9.64039 11.2683 10.0084 11.274 10.3763 11.2718C10.7851 11.2704 11.1946 11.2718 11.6033 11.2718L11.602 11.2711ZM14.7632 14.4026C14.7772 14.3331 14.7933 14.2884 14.7939 14.2445C14.796 13.0763 14.804 11.9074 14.7879 10.7392C14.7859 10.6016 14.6755 10.4384 14.5738 10.3334C13.773 9.5135 12.9628 8.7042 12.1539 7.89278C12.0937 7.83249 12.0235 7.78426 11.9332 7.71049V11.2208C12.4938 11.3151 12.4958 11.3151 12.5246 11.9173C12.5641 12.7386 12.6002 13.5607 12.639 14.4019H14.7632V14.4026Z",
    fill: "url(#paint0_linear_992_7992)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_992_7992",
    x1: 9.63404,
    y1: 1.2207,
    x2: 9.63404,
    y2: 17.9817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorViewYellow);
export default __webpack_public_path__ + "static/media/floor_view_yellow.a186235266b8e1af69f67e597e33877e.svg";
export { ForwardRef as ReactComponent };